const isoConsent = {
  AT: { defaultConsent: undefined, isShown: true },
  BE: { defaultConsent: undefined, isShown: true },
  BG: { defaultConsent: undefined, isShown: true },
  HR: { defaultConsent: undefined, isShown: true },
  CY: { defaultConsent: undefined, isShown: true },
  CZ: { defaultConsent: undefined, isShown: true },
  DK: { defaultConsent: undefined, isShown: true },
  EE: { defaultConsent: undefined, isShown: true },
  FI: { defaultConsent: undefined, isShown: true },
  FR: { defaultConsent: undefined, isShown: true },
  DE: { defaultConsent: undefined, isShown: true },
  GR: { defaultConsent: undefined, isShown: true },
  HU: { defaultConsent: undefined, isShown: true },
  IE: { defaultConsent: undefined, isShown: true },
  IS: { defaultConsent: undefined, isShown: true },
  IT: { defaultConsent: undefined, isShown: true },
  LV: { defaultConsent: undefined, isShown: true },
  LI: { defaultConsent: undefined, isShown: true },
  LT: { defaultConsent: undefined, isShown: true },
  LU: { defaultConsent: undefined, isShown: true },
  MT: { defaultConsent: undefined, isShown: true },
  NL: { defaultConsent: undefined, isShown: true },
  NO: { defaultConsent: undefined, isShown: true },
  PL: { defaultConsent: undefined, isShown: true },
  PT: { defaultConsent: undefined, isShown: true },
  RO: { defaultConsent: undefined, isShown: true },
  SK: { defaultConsent: undefined, isShown: true },
  SI: { defaultConsent: undefined, isShown: true },
  ES: { defaultConsent: undefined, isShown: true },
  SE: { defaultConsent: undefined, isShown: true },
  MX: { defaultConsent: undefined, isShown: true },
  GB: { defaultConsent: undefined, isShown: true },
  PE: { defaultConsent: false, isShown: true },
  CO: { defaultConsent: false, isShown: true },
  TR: { defaultConsent: false, isShown: true },
  TW: { defaultConsent: false, isShown: true },
  VN: { defaultConsent: false, isShown: true },
  AE: { defaultConsent: false, isShown: true },
  JP: { defaultConsent: false, isShown: true },
  KR: { defaultConsent: false, isShown: true },
  IL: { defaultConsent: false, isShown: true },
};

const getEmailConsent = iso => (
    iso in isoConsent
    ? isoConsent[iso]
    : { defaultConsent: undefined, isShownForCountry: false }
);

export default getEmailConsent;



// WEBPACK FOOTER //
// ./src-react/lib/getEmailConsent.js